
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import smVoiceLog from './compoments/smVoiceLog'
import userOrder from './compoments/userOrder'
import {queryuserbalance} from '../../api/pay'
export default {
name: 'payDetails',
directives: {
TransferDom
},
components: {smVoiceLog, userOrder},
data () {
return {
selectTitle: 0,
openShow: false,
showNotify: false,
userbalance: {
balance_new: 0,
balance_sms: 0,
balance_voice: 0
}
}
},
computed: {
numStyle () {
let result = 'width: 100%'
if (this.userbalance.balance_sms !== 0 && this.userbalance.balance_voice !== 0) {
result = 'width: 33%'
} else if (this.userbalance.balance_sms !== 0 || this.userbalance.balance_voice !== 0) {
result = 'width: 50%'
} else {
result = 'width: 100%'
}
return result
}
},
created () {
this.showNotify = true
this.getSumData()
document.getElementsByTagName('title')[0].innerText = '支付详情'
},
beforeDestroy () {
document.getElementsByTagName('title')[0].innerText = '智慧安防'
},
methods: {
getSumData () {
let data = {
phone: this.$store.getters.get_user
}
queryuserbalance(data).then(res => {
this.userbalance = res.data.userbalance
}).catch(() => {})
},
openTitleSelect (index) {
this.selectTitle = index
},
openPay () {
this.$router.push('/payCenter')
},
sendPay () {}
}
}



// WEBPACK FOOTER //
// ./src/components/more/payDetails.vue